export default "__VITE_ASSET__KooD3VQb__"